import React, { useState } from "react";
import { useTranslation } from "../../i18n/TranslationProvider";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers";
import sendMessageSchema from "./validations/sendMessageSchema";

import { Col, Form, Row } from "react-bootstrap";
import ComponentWrapper from "./ComponentWrapper";
import LabelledInput from "../UIComponents/LabelledInput";
import SubmitButton from "../UIComponents/SubmitButton";
import Button2 from "../UIComponents/Button2";

import { sendMessage } from "../../api/messageRequests";

const SendMessage = ({
  fillColumn,
  messageRecipient,
  messageRecipientType,
  userType,
  loadMessages,
  curReceiverId,
}) => {
  const filteredRecipients = messageRecipient.filter((recipient) => {
    return recipient.receiver_id === curReceiverId;
  });

  const { t } = useTranslation();
  const [patientMessageRecipient, setPatientMessageRecipient] = useState("");
  const [name, setName] = useState("");
  const [inputVisible, setInputVisible] = useState(false);
  const [submitDisabled, setSubmitDisabled] = useState(false);
  const [messageSent, setMessageSent] = useState(false);

  const { register, handleSubmit, errors, setError } = useForm({
    resolver: yupResolver(sendMessageSchema),
  });

  const onSubmit = (data) => {
    setSubmitDisabled(true);
    data.recipientId = patientMessageRecipient;
    sendMessage(data)
      .then(() => {
        setMessageSent(true);
        setInputVisible(false);
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setSubmitDisabled(false);
      });
  };

  return (
    <ComponentWrapper fillColumn={fillColumn}>
      <Row className="p-2">
        <Col>
          <span className="text-center">{t("sendmessage.label")}</span>
        </Col>
      </Row>
      <Row className={`p-2 ${fillColumn && !inputVisible ? " h-100" : ""}`}>
        <Col className="d-flex flex-column flex-wrap justify-content-around text-center">
          <div>
            {filteredRecipients.map((recipient) => {
              return (
                <Button2
                  key={recipient.receiver_id}
                  onClick={() => {
                    setInputVisible(true);
                    setMessageSent(false);
                    setPatientMessageRecipient(recipient.receiver_id);
                    setName(recipient.first_name + " " + recipient.last_name);
                  }}
                >
                  {t("sendmessage.send_message_to")}
                  {recipient.first_name + " " + recipient.last_name}
                </Button2>
              );
            })}
          </div>
          {patientMessageRecipient ? (
            <Button2
              onClick={() => {
                setPatientMessageRecipient("");
                setInputVisible(false);
              }}
            >
              {t("sendmessage.back_to_selection")}
            </Button2>
          ) : null}
        </Col>
      </Row>
      {inputVisible && (
        <Row className="p-2">
          <Col>
            <Form onSubmit={handleSubmit(onSubmit)}>
              <Row className="p-2">
                <Col>
                  <LabelledInput
                    required
                    label={t("messages.table.message")}
                    name="body"
                    errors={errors}
                    inputRef={register}
                    inputAs="textarea"
                    rows={3}
                  />
                  <SubmitButton type="submit" disabled={submitDisabled}>
                    {t("sendmessage.send")}
                  </SubmitButton>
                </Col>
              </Row>
            </Form>
          </Col>
        </Row>
      )}
      {messageSent && (
        <Row className="p-2">
          <Col className="text-center">
            {t("sendmessage.message_sent")} {name}.
          </Col>
        </Row>
      )}
    </ComponentWrapper>
  );
};

export default SendMessage;